import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from './pages/Home.jsx'
import Products from './pages/Products.jsx'
import ProductDetails from "./pages/ProductDetails.jsx";
import Cart from './pages/Cart.jsx'
import Checkout from "./pages/Checkout.jsx";
import About from './pages/About.jsx'
import Contact from './pages/Contact.jsx'
import Login from './pages/Login.jsx'
import Signup from './pages/Signup.jsx'
import UserProfile from "./pages/UserProfile";
import "./styles.css";
import Chatbot from './components/Chatbot.jsx'
import OrderConfirmation from "./pages/OrderConfirmation";
import MyOrders from "./pages/MyOrders.jsx";

const Layout = ({ children }) => (
  <>
    <Navbar />
    {children}
    <Footer />
    <Chatbot />
  </>
);

export default function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/product/:id" element={<ProductDetails />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/profile" element={<UserProfile />} />
          <Route path="/order-confirmation/:orderId" element={<OrderConfirmation />} />
          <Route path="/orders" element={<MyOrders />} />
        </Routes>
      </Layout>
    </Router>
  );
}
